/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import ProductTile from '@salesforce/retail-react-app/app/theme/components/project/product-tile'

export default {
    ...ProductTile,
    baseStyle: () => {
        const base = ProductTile.baseStyle()
        return {
            ...base,
            price: {
                fontSize: '16px',
                fontWeight: '300',
                fontFamily: 'body',
                color: 'black.100'
            },
            badgeGroup: {
                color: '#a86500',
                fontSize: '13px',
                fontWeight: '400',
                fontFamily: 'body',
                lineHeight: '20px'
            },
            badgeStack: {
                textValue: {
                    width: 'auto',
                    paddingLeft: '0px'
                },
                xxValue: {
                    width: 'auto',
                    paddingTop: '0px'
                },
                default: {
                    width: '100%'
                }
            },
            promotionsWrapper: {
                main: {
                    display: 'flex',
                    width: 'fit-content',
                    gap: '10px'
                },
                promo: {
                    background: 'green.100',
                    color: 'green.500',
                    paddingX: '6px',
                    paddingY: 0,
                    borderRadius: '0px',
                    fontSize: '11px',
                    lineHeight: '22px',
                    letterSpacing: '0.055px'
                }
            },
            title: {
                ...base.title,
                fontSize: '18px',
                fontWeight: '400',
                margin: '0px 10px 10px 0',
                textAlign: 'left',
                fontFamily: 'heading',
                minHeight: '54px',
                color: 'black.100',
                _hover: {textDecoration: 'none', color: 'blue.700'},
                sx: {
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    overflow: 'hidden'
                },
                width: '100%'
            },
            link: {
                ...base.link,
                _hover: {textDecoration: 'none'}
            },
            brandLogo: {
                position: 'absolute',
                bottom: {base: 'unset', md: 'unset', lg: '20px'},
                top: {base: '0.5rem', md: '0.5rem', lg: 'unset'},
                left: {base: '0.5rem', md: '0.5rem', lg: '20px'},
                width: '1.5rem',
                height: '1.5rem'
            },
            mobileImages: {
                main: {
                    overflowX: 'scroll',
                    display: 'flex',
                    scrollSnapType: 'x mandatory',
                    css: {
                        '&::-webkit-scrollbar': {
                            display: 'none'
                        }
                    }
                },
                box: {
                    position: 'relative',
                    w: '100%',
                    overflow: 'hidden',
                    display: {base: 'block', md: 'none', lg: 'none'}
                },
                imageWrapper: {
                    flex: 'none',
                    w: '100%',
                    h: 'auto',
                    scrollSnapAlign: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '1px'
                },
                sliderDots: {
                    position: 'absolute',
                    bottom: '10px',
                    left: '10px',
                    spacing: 2,
                    zIndex: 10
                },
                asset: {
                    objectFit: 'cover',
                    w: '100%',
                    h: '100%'
                }
            },
            motionBox: {
                position: 'absolute',
                width: '14px',
                height: '12px',
                transition: {duration: 0.7, ease: 'easeInOut'}
            },
            quickAdd: {
                main: {
                    textAlign: 'center',
                    bottom: '0px',
                    position: {base: 'unset', lg: 'absolute'},
                    opacity: {base: 1, lg: 0},
                    pointerEvents: {base: 'auto', lg: 'none'},
                    transition: '0.3s ease',
                    width: '100%'
                },
                button: {
                    color: 'black.100',
                    fontFamily: 'body',
                    fontSize: '14px',
                    padding: '4px 25px',
                    borderRadius: '40px',
                    margin: 'auto',
                    height: 'unset',
                    marginBottom: {lg: '15px'},
                    transition: 'all 0.3s ease',
                    lineHeight: '22px',
                    fontWeight: '300',
                    border: '1px solid',
                    borderColor: 'gray.450',
                    backgroundColor: 'white',
                    _hover: {
                        borderColor: 'black.100'
                    },
                    _focusVisible: {
                        boxShadow: 'none'
                    },
                    _active: {
                        backgroundColor: 'white'
                    }
                },
                sizesWrapper: {
                    textAlign: 'left',
                    backgroundColor: 'white',
                    width: 'calc(100% - 30px)',
                    display: {base: 'none', lg: 'inline-flex'},
                    flexWrap: 'wrap',
                    gap: '10px',
                    margin: '15px 15px 15px 15px'
                },
                sizeSwatch: {
                    margin: '0 !important',
                    minWidth: '60px',
                    borderRadius: '3px',
                    fontSize: '13px',
                    _hover: {
                        borderColor: 'transparent'
                    }
                },
                drawerContent: {
                    marginTop: 0,
                    padding: '15px 15px 0 15px',
                    borderRadius: '20px 20px 0 0'
                },
                drawerHeader: {
                    boxShadow: 'none',
                    padding: '0 !important',
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '20px'
                }
            },
            yrBrandIcon: {
                width: '20px',
                position: 'absolute',
                bottom: {base: 'unset', md: '10px'},
                top: {base: '10px', md: 'unset'},
                left: '10px',
                height: '24px'
            }
        }
    }
}
